<template>
  <div class='EnbPainel'>
    <global-spinner v-if="GlobalLoading"/>
    <enb-msg/>
    <enb-modal v-if="EnbModal.active"/>
    <enb-sidebar/>
    <side-nave-mobi-painel v-if="SideNave"/>
    <div class="cont-painel">
      <enb-nave-mobi-painel/>
      <div class="label">
        <enb-label
        :text="textLabel"
        config="font-weight:bold;font-size:18px;color:#648EEA;text-align:left;padding:1.5%"
        />
      </div>
      <div class="cont" >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EnbSidebar from '@/components/EnbPainel/EnbSidebar.vue'
import EnbLabel from '@/components/EnbLabel.vue';
import EnbModal from '@/components/EnbPainel/Modal/EnbModal'
import EnbMsg from '@/components/EnbMsg/EnbMsg'
import GlobalSpinner from '@/components/Spinner/GlobalSpinner'
import Mobile from '@/components/Mobile'
export default {
  name: 'EnbPainel',
  components: { EnbSidebar, EnbLabel, EnbModal, EnbMsg, GlobalSpinner, ...Mobile },
  computed: {
    ...mapGetters(['EnbModal', 'GlobalLoading', 'Empresa', 'SideNave']),
    textLabel () {
      if(this.Empresa.modelo === 'Modelo 03') {
        if(this.$route.name === 'Produtos') {
          return 'Captações'
        }
        if(this.$route.name === 'Adicionar produto') {
          return 'Adicionar captação'
        }
        if(this.$route.name === 'Editar produto') {
          return 'Editar captação'
        }
        if(!this.$route.name) {
          return this.$route.matched[this.$route.matched.length - 2].name
        }
        return this.$route.name
      }
      if(!this.$route.name) {
        return this.$route.matched[this.$route.matched.length - 2].name
      }
      return this.$route.name
    }
  }
}
</script>

<style scoped>
.EnbPainel {
  width: 100%;
  height: 100%;
  display: flex;
}

.cont-painel {
  width: 80%;
  height: 100%;
  box-shadow: 0px 0px 4px 1px #CCCCCC;
}

.label {
  height: 8%;
}

.cont {
  height: 92%;
}

@media (max-width: 500px) {
  .cont-painel {
    width: 100%;
  }
}
</style>
